import React, { Component } from 'react';
import TopMenu from '../components/TopMenu';
import { userService } from '../_services/user.service';
import WholesalerDashboard from '../components/Wholesaler/Dashboard';
import DistributorDashboard from '../components/Distributor/Dashboard';
import AdminDashboard from '../components/Admin/Dashboard';
import SubAdminDashboard from '../components/SubAdmin/Dashboard';
import BrokerDashboard from '../components/Broker/Dashboard';
import $ from 'jquery';

class Dashboard extends Component {
    constructor(props) {
        super(props);
        var startdate = new Date();
        startdate.setDate(startdate.getDate() - 30);
        var enddate = new Date();
        if (localStorage.getItem('User_Start_Date') != "" && localStorage.getItem('User_Start_Date') != null && localStorage.getItem('User_Start_Date') != undefined) {
            startdate = localStorage.getItem('User_Start_Date');
        }
        if (localStorage.getItem('User_End_Date') != "" && localStorage.getItem('User_End_Date') != null && localStorage.getItem('User_End_Date') != undefined) {
            enddate = localStorage.getItem('User_End_Date');
        }
        if (localStorage.getItem('user') == null || localStorage.getItem('user') == "" || localStorage.getItem('user') == "{}") {
            userService.logout();
        }
        try {
            this.state = {
                // users: null,
                dashboardListRendered: false,
                dashboardName: JSON.parse(localStorage.getItem('user')).dList[0].dashboardName,
                startDate: startdate,
                endDate: enddate,
                DisshowPopup: false,
                SubDisshowPopup: false,
                userdata: JSON.parse(localStorage.getItem('user')),
                AllDirectOverride: '',
                dist_usertype: 'N/A'
            };
        }
        catch (error) { }

        this.dashboardListRendered = this.dashboardListRendered.bind(this);
    }

    componentDidMount() {
        // $("#main-menu > a");
        $("#main-menu li:first-child a").addClass('active');
        var user = JSON.parse(localStorage.getItem('user'));
        this.setState({
            userdata: user
        });
        userService.getUser(user.id, user.authdata).then(
            users => this.setState({ users })
        );
    }

    dashboardListRendered(e) {
        try {
            this.setState({
                ...this.state,
                dashboardListRendered: true,
                dashboardName: e
            })
        }
        catch (error) { }
        this.dashboardListRendered = this.dashboardListRendered.bind(this);
    }


    handeChangefilter = (e) => {
        this.setState({
            ...this.state,
            userdata: JSON.parse(localStorage.getItem('user'))
        });
    }
    handleChangeAllDirectOverride = (e) => {
        try {
            this.setState({
                ...this.state,
                userdata: JSON.parse(localStorage.getItem('user')),
                dist_usertype: e
            });
        }
        catch (error) {
        }
    }
    handleAllDirectOverride_user = (e) => {
        try {
            this.setState({
                ...this.state,
                AllDirectOverride: e
            });
        }
        catch (error) {
        }
    }
    //handleChangeStart = (date) => {
    //    debugger;
    //    this.setState({
    //        ...this.state,
    //        startDate: date
    //    });
    //}


    //handleChangeEnd = (date) => {
    //    try {
    //        this.setState({
    //            ...this.state,
    //            endDate: date
    //        });
    //    }
    //    catch (error) { }
    //}

    handleChangeStartEnd = (d) => {
        try {
            this.setState({
                ...this.state,
                startDate: d.split('-')[0],
                endDate: d.split('-')[1]
            });
        }
        catch (error) {
        }
    }

    handleChange = (e) => {
        this.setState({
            ...this.state,
            dashboardName: e
        })
    }
    render() {
        return (
            <div className="dashboard">
                <h2 className="dashboardHeading">Dashboard</h2>
                {/*<TopMenu dashboardListRendered={this.dashboardListRendered} handleChange={this.handeChange} handleChangeStart={this.handleChangeStart} handleChangeEnd={this.handleChangeEnd} handeChangefilter={this.handeChangefilter}  dashboardTitle={this.state.dashboardTitle} startDate={this.state.startDate} endDate={this.state.endDate} /> */}
                <TopMenu dashboardListRendered={this.dashboardListRendered} handleChange={this.handeChange} handleChangeDateNew={this.handleChangeStartEnd} handeChangefilter={this.handeChangefilter} dashboardTitle={this.state.dashboardTitle} startDate={this.state.startDate} endDate={this.state.endDate} handleChangeAllDirectOverride={this.handleChangeAllDirectOverride} />

                {

                    this.state.dashboardListRendered &&
                    <this.RenderDashboard dashboardProps={this.state} handelchange={this.handeChangefilter} handlealldirectoverride={this.handleAllDirectOverride_user} />
                }
            </div>

        )

    }

    RenderDashboard(props) {
        if (!!props && !!props.dashboardProps) {
            try {
                if (props.dashboardProps.userdata.userrole == "Wholesaler") {
                    return <WholesalerDashboard dist_usertype={props.dashboardProps.dist_usertype} dashboardName={props.dashboardProps.userdata.dList[0].dashboardName} handeChangefilter={props.handelchange} handleAllDirectOverride_user={props.handlealldirectoverride} startDate={props.dashboardProps.startDate} endDate={props.dashboardProps.endDate} />
                }
                else if (props.dashboardProps.userdata.isBrokerTypeUser == true) {
                    return <BrokerDashboard dist_usertype={props.dashboardProps.dist_usertype} dashboardName={props.dashboardProps.userdata.dList[0].dashboardName} handeChangefilter={props.handelchange} handleAllDirectOverride_user={props.handlealldirectoverride} startDate={props.dashboardProps.startDate} endDate={props.dashboardProps.endDate} Wholesaler={props.dashboardProps.userdata.wholesaler} DisEmail={props.dashboardProps.userdata.email} DisName={props.dashboardProps.userdata.userName} />
                }
                else if (props.dashboardProps.userdata.userrole == "Distributor") {
                    return <DistributorDashboard dist_usertype={props.dashboardProps.dist_usertype} dashboardName={props.dashboardProps.userdata.dList[0].dashboardName} handeChangefilter={props.handelchange} handleAllDirectOverride_user={props.handlealldirectoverride} startDate={props.dashboardProps.startDate} endDate={props.dashboardProps.endDate} Wholesaler={props.dashboardProps.userdata.wholesaler} DisEmail={props.dashboardProps.userdata.email} DisName={props.dashboardProps.userdata.userName} />
                }
                else if (props.dashboardProps.userdata.userrole == "SubAdmin") {
                    return <SubAdminDashboard dashboardName={props.dashboardProps.userdata.dList[0].dashboardName} handeChangefilter={props.handelchange} startDate={props.dashboardProps.startDate} endDate={props.dashboardProps.endDate} />
                }
                else {
                    return <AdminDashboard dashboardName={props.dashboardProps.userdata.dList[0].dashboardName} handeChangefilter={props.handelchange} startDate={props.dashboardProps.startDate} endDate={props.dashboardProps.endDate} />
                }
            }
            catch (error) {
                if (props.dashboardProps.userdata.userrole == "Wholesaler") {
                    return <WholesalerDashboard dashboardName={this.state.userdata[0].paramsname} handeChangefilter={props.dashboardProps.handelchange} startDate={props.dashboardProps.startDate} endDate={props.dashboardProps.endDate} />
                }
                else if (props.dashboardProps.userdata.isBrokerTypeUser == true) {
                    return <BrokerDashboard dist_usertype={props.dashboardProps.dist_usertype} dashboardName={this.state.userdata[0].paramsname} handeChangefilter={props.dashboardProps.handelchange} handleAllDirectOverride_user={props.handlealldirectoverride} startDate={props.dashboardProps.startDate} endDate={props.dashboardProps.endDate} Wholesaler={this.state.userdata[0].wholesaler} DisEmail={this.state.userdata[0].email} DisName={this.state.userdata[0].paramsname} />
                }
                else if (props.dashboardProps.userdata.userrole == "Distributor") {
                    return <DistributorDashboard dist_usertype={props.dashboardProps.dist_usertype} dashboardName={this.state.userdata[0].paramsname} handeChangefilter={props.dashboardProps.handelchange} handleAllDirectOverride_user={props.handlealldirectoverride} startDate={props.dashboardProps.startDate} endDate={props.dashboardProps.endDate} Wholesaler={this.state.userdata[0].wholesaler} DisEmail={this.state.userdata[0].email} DisName={this.state.userdata[0].paramsname} />
                }
                else if (props.dashboardProps.userdata.userrole == "SubAdmin") {
                    return <SubAdminDashboard dashboardName={this.state.userdata[0].paramsname} handeChangefilter={props.dashboardProps.handelchange} startDate={props.dashboardProps.startDate} endDate={props.dashboardProps.endDate} />
                }
                else {
                    return <AdminDashboard dashboardName={this.state.userdata[0].paramsname} handeChangefilter={props.dashboardProps.handelchange} startDate={props.dashboardProps.startDate} endDate={props.dashboardProps.endDate} />
                }
            }
        }
    }
}
export default Dashboard;